<template>
    <!-- 全部列表 -->
    <div>
        <skeleton-screen-card v-if="!isCloseSkeletonScreen" :data="3" />
        <div v-if="isCloseSkeletonScreen">
            <!-- 战绩榜 -->
            <notice-banner
                v-if="noticeList && noticeList.length > 0"
                :noticeList="noticeList"
                :teacherInfo="teacherInfo"
            ></notice-banner>

            <!-- 直播卡片 -->
            <top-live-card
                v-if="liveCardInfo"
                :liveCardInfo="liveCardInfo"
                :teacherInfo="teacherInfo"
            ></top-live-card>

            <!-- 列表 -->
            <div v-if="msg_list.length" style="background-color: #F5F6F7;">
                <app-live-list-pub
                    v-for="(item, index) in msg_list"
                    :pageName="pageName"
                    :key="item.id"
                    :live="teacherInfo"
                    :msg="item"
                    :is_vip="is_vip"
                    :teacherInfo="teacherInfo"
                    :indexItem="index"
                    :isSelf="isSelf"
                    :forward_vip_content="item.forward_vip_content"
                    :vip_content="item.vip_content"
                    :apptextSize="apptextSize"
                ></app-live-list-pub>
            </div>
            <no-result v-if="!msg_list.length" title="暂无专栏~"></no-result>
            <loading-dom
                class="loadbox"
                loadType="small"
                :title="'正在加载中...'"
                v-if="msg_list.length && listLoading"
            ></loading-dom>
            <no-data msg="已经到底了~" v-if="!listLoading && hasMore && msg_list.length"></no-data>
        </div>
    </div>
</template>
<script>
import userHomeApi from "@/api/user_home/index.js";

export default {
    name: "UserProfiles",
    components: {
        appLiveListPub:() => import('@/components/userHome/app-live-list-pub.vue'),
        TopLiveCard: () => import("@/components/userHome/topLiveCard.vue"), // 顶部直播卡片
        noData: () => import("@/components/userHome/components/noData.vue"),
        noResult: () => import("@/components/userHome/components/noResult.vue"),
        loadingDom: ()=> import("@/components/userHome/components/loading.vue"),
        noticeBanner: () => import("@/components/userHome/noticeBanner.vue"),
        skeletonScreenCard: () => import("@/components/userHome/components/skeletonScreen.vue")
    },
    computed: {
        userInfo() {
            return this.$store.state.userProfiles.userInfo;
        }
    },
    props: {
        pageType: {
            type: String,
            default: "teacher"
        },
        teacherInfo: {
            type: Object,
            default: ()=>{
                return {}
            }
        },
        liverNoticeList: {
            type: Array,
            default: () => {
                return []
            }
        },
        liveCardInfo: { // 直播卡片信息
            type: Object,
            default: ()=>{
                return {}
            }
        },
        pageName: {
            type: String,
            default: "",
        },
        isSelf: {
            type: Boolean,
            default: false
        },
        apptextSize: {
            type: String,
            default: "normal"
        }
    },
    data() {
        return {
            user_id: parseInt(this.$route.query.id) || 0,
            l_id: parseInt(this.$route.query.l_id) || 0,
            msg_list: [],
            isCloseSkeletonScreen: false,

            listLoading: false,
            hasMore: false,
            before: 0,
            is_vip: "",
            noticeList: []
        };
    },
    watch: {
        liverNoticeList: {
            handler(newVal, oldVal) {
                if(newVal && newVal.length > 0) {
                    this.noticeList = newVal;
                }
            },
            deep: true//监听父组件数据变化
        }
    },
    created() {
        //获取用户全部数据
        this.init();
    },
    methods: {
        init() {
            //获取用户全部数据
            this.getCenterList();
        },
        columnListMore() {
            if (this.msg_list.length === 0 || this.listLoading || this.hasMore) {
                return
            };

            this.before = this.msg_list[this.msg_list.length - 1].rec_time;

            this.init();
        },
        reloadList() {
            this.before = 0;
            this.msg_list = [];
            //获取用户全部数据
            this.getCenterList('close');
        },
        editItemFn(obj) {
            let {itemIndex, query} = obj;
            if(itemIndex >= 0) {
                for(let item in query) {
                    this.$set(this.msg_list[itemIndex], item, query[item]);
                }
            }
        },
        delItemFn(obj) {
            let {itemIndex} = obj;
            if(itemIndex >= 0) {
                this.msg_list.splice(itemIndex, 1)
            }
        },
        editRSAStr(obj) {
            let {itemIndex, isForward, content} = obj;
            if(itemIndex >= 0) {
                this.$set(this.msg_list[itemIndex], isForward?'forward_vip_content': 'vip_content', content);
            }
        },
        //获取老师个人主页全部直播列表
        async getCenterList(type) {

            if (this.listLoading) {
                return
            }

            this.listLoading = true;

            let params = {
                kind: "charge",
                act: "msg",
                division: 3,
                id: this.l_id,
                before: this.before
            }
            if(params.before > 0) {
                params.allnumber = 11;
            }
            let centerList = await userHomeApi.getLiveCenter(params);

            if(centerList && centerList.rslt == 'succ') {
                if (centerList.msg_list && centerList.msg_list.length > 0) {
                    let insertData = centerList.msg_list;
                    if (this.before) {
                        this.msg_list = this.msg_list.concat(insertData);
                    } else {
                        if(centerList.top_msg_list && centerList.top_msg_list.length > 0) {
                            insertData.unshift(...centerList.top_msg_list)
                        }
                        this.msg_list = insertData;
                        this.$forceUpdate();
                    }
                    this.is_vip = centerList.is_vip;
                    this.isData(insertData);
                } else {
                    this.hasMore = true;
                }   
            }
            this.listLoading = false;
            this.isCloseSkeletonScreen = true;
            
            if(type) {
                this.$srH5CallNativeMethodApp('refresh_done',{})
            }
            // this.$emit("scrollRefresh");
        },
        isData(data) {
            if (!data.length) {
                this.hasMore = true;
            } else {
                this.hasMore = false;
            }
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";

.recommend {
    position: fixed;
    overflow: auto;
    top: 48px;
    width: 100%;
    padding-bottom: 50px;
    bottom: 0;
    background-color: #f0f0f0;
}

.recommend-content {
    height: 100%;
    overflow: hidden;
}
</style>